<template>
    <div>
        <page-header :title="isInEditMode ? $t('pages.admin.blog.create_edit.title_edit') + ': ' + title : $t('pages.admin.blog.create_edit.title_create')" />

        <img :src="current_thumbnail_url" class="img-fluid mb-4 rounded" v-if="current_thumbnail_url !== null">

        <div class="card shadow-sm">
            <div class="card-body">
                <div class="form-group">
                    <label>
                        <span v-if="isInEditMode">{{ $t('pages.admin.blog.create_edit.replace_thumbnail') }}</span>
                        <span v-else>{{ $t('pages.admin.blog.create_edit.select_thumbnail') }}</span>
                    </label>
                    <input type="file" class="file-upload-default" id="image" :class="{'is-invalid': $errors.has('image')}" @change="imageSelected">
                    <div class="input-group cursor-pointer col-xs-12" @click="showSelectFileDialog">
                        <input type="text" id="image-upload" class="form-control file-upload-info" disabled="" :placeholder="$t('pages.admin.blog.create_edit.select_thumbnail')">
                        <span class="input-group-append">
                            <button class="file-upload-browse btn btn-gradient-primary" type="button">{{ $t('actions.select') }}</button>
                        </span>
                        <error input="image"/>
                    </div>
                    <small class="form-text text-muted">{{ $t('pages.admin.blog.create_edit.thumbnail_explanation') }}</small>
                </div>

                <div class="form-group">
                    <label :for="'title'">{{ $t('pages.admin.blog.model.title') }}</label>
                    <input :id="'title'" type="text" class="form-control form-control-lg" :class="{'is-invalid': $errors.has('title')}" :placeholder="$t('pages.admin.blog.model.title')" v-model="title">
                    <error-no-form-field :input="'title'"/>
                </div>

                <div class="form-group">
                    <label :for="'contents'">{{ $t('pages.admin.blog.model.contents') }}</label>
                    <VueTrix :id="'contents'" v-model="contents" :placeholder="$t('pages.admin.blog.model.contents')"></VueTrix>
                    <error-no-form-field :input="'contents'"/>
                </div>

                <div class="form-group" v-if="isInEditMode && existingFiles.length">
                    <label>
                        {{ $t('pages.admin.blog.create_edit.existing_files') }}
                    </label>
                    <div class="row">
                        <div class="col-md-6" v-for="file in existingFiles" :key="file.id">
                            <div class="card bg-light mb-2">
                                <div class="card-body p-2">
                                    <div v-if="isFileSelectedForDeletion(file)">
                                        <del class="text-danger">
                                            <strong>{{ file.name }}</strong>
                                            ({{ convertBytesToHumanReadable(file.size) }})
                                        </del>
                                        <button class="btn btn-sm btn-outline-success float-right" @click="selectExistingFile(file)">
                                            {{ $t('actions.keep') }}
                                        </button>
                                    </div>
                                    <div v-else>
                                        <span>
                                            <strong>{{ file.name }} </strong>
                                            ({{ convertBytesToHumanReadable(file.size) }})
                                        </span>
                                        <button class="btn btn-sm btn-outline-danger float-right" @click="selectExistingFile(file)">
                                            {{ $t('actions.delete') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="fileDropzone">
                        {{ $t('pages.admin.blog.create_edit.upload_files') }}
                    </label>
                    <vue-dropzone ref="fileDropzone"
                                  id="fileDropzone"
                                  @vdropzone-files-added="dropzoneFilesAdded"
                                  @vdropzone-removed-file="dropZoneFileRemoved"
                                  :options="dropzoneOptions" v-if="dropzoneOptions !== null"></vue-dropzone>
                </div>

                <button class="btn btn-primary" @click="saveSeries">
                    {{ isInEditMode ? $t('actions.update') : $t('actions.create') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../../Includes/PageHeader";
import AdminBlogRepository from "../../../repositories/Admin/AdminBlogRepository";
import VueTrix from "vue-trix";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
    name: "BlogPostAddUpdate",
    components: {PageHeader, VueTrix, vueDropzone: vue2Dropzone},
    data: () => ({
        title: "",
        contents: "",
        image: null,
        existingFiles: [],
        files: [],

        filesToDelete: [],

        current_thumbnail_url: null,

        dropzoneOptions: null
    }),
    mounted() {
        this.dropzoneOptions = {
            url: 'https://xyz.test', // Don't remove, as its required.
            thumbnailWidth: 150,
            maxFilesize: 30,
            addRemoveLinks: true,
            uploadMultiple: true,
            autoProcessQueue: false,
            parallelUploads: 1,
            dictDefaultMessage: this.$t('pages.admin.blog.create_edit.drop_file')
        };

        if(this.isInEditMode) {
            AdminBlogRepository
                .getPost(this.postId)
                .then((res) => {
                    this.title = res.data.title;
                    this.contents = res.data.contents;
                    this.current_thumbnail_url = res.data.thumbnail_url;
                    this.existingFiles = res.data.files;
                });
        }
    },
    methods: {
        /* File Upload */
        imageSelected(e) {
            this.image = e.target.files[0];
            let fileUploadInfoInput = document.getElementById('image-upload');
            fileUploadInfoInput.value = this.image.name;
            fileUploadInfoInput.value = fileUploadInfoInput.value.replace(/C:\\fakepath\\/i, '');
        },
        showSelectFileDialog() {
            let file = document.getElementsByClassName('file-upload-default')[0];
            file.click();
        },

        selectExistingFile(file) {
            if(this.isFileSelectedForDeletion(file)) {
                this.filesToDelete = this.filesToDelete.filter(f => f.id !== file.id);
            } else {
                this.filesToDelete.push(file);
            }
        },
        isFileSelectedForDeletion(file) {
            return this.filesToDelete.find(f => f.id === file.id) !== undefined;
        },

        dropzoneFilesAdded(fileList) {
            // $nextTick is necessary, because otherwise files added using drag & drop result in file.status being undefined...
            // However, it works for files added through the OS-Dialog. Odd bug
            this.$nextTick(() => {
                Array.from(fileList)
                    .filter(file => file.accepted)
                    .forEach(file => {
                        this.files.push(file);
                    });
            });

            //console.log(this.files);
        },
        dropZoneFileRemoved(file, error, xhr) {
            this.files = this.files.filter(existingFile => {
                return existingFile.name !== file.name;
            });
        },

        /* Series */
        updatePost() {
            AdminBlogRepository
                .updatePost(this.postId, this.getFormData()).then((res) => {
                    this.$snotify.success(this.$t('actions.updated'));
                    this.$router.push({name: 'admin.blog.index'});
                });
        },
        getFormData() {
            let formData = new FormData();
            if(this.image !== null)
                formData.append('image', this.image);

            formData.append('title', this.title);
            formData.append('contents', this.contents);

            this.files.forEach((file, i) => formData.append(`files[${i}]`, file));

            if(this.isInEditMode) {
                if(this.getFilesToDelete.length) {
                    this.getFilesToDelete.forEach((fileId, i) => {
                        formData.append(`filesToDelete[${i}]`, fileId);
                    })
                }
            }

            return formData;
        },
        addPost() {
            AdminBlogRepository.createPost(this.getFormData()).then((res) => {
                if(this.isInEditMode) {
                    this.$snotify.success(this.$t('actions.created'));
                } else {
                    this.$snotify.success(this.$t('actions.updated'));
                }
                this.$router.push({name: 'admin.blog.index'});
            });
        },
        saveSeries() {
            if(this.isInEditMode)
                this.updatePost();
            else
                this.addPost();
        },
    },
    computed: {
        getFilesToDelete() {
            return this.filesToDelete.flatMap(f => f.id);
        },
        postId() {
            return this.$route.params.postId;
        },
        isInEditMode() {
            return this.postId !== undefined;
        }
    }
}
</script>

<style scoped>
</style>
